<template>
  <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: "Livraisons",
          icon: "bi bi-truck",
          route: "deliveries-index",
        },
        {
          label: "Nouvelle livraison",
          icon: "bi bi-box-seam-fill",
          route: "deliveries-create",
        },
      ],
    };
  },
};
</script>
